var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditional1ActivityCoral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 12,
    fill: "#FFE7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07841 14.308V12.484H6.27841V11.116H8.07841V9.292H9.49441V11.116H11.2944V12.484H9.49441V14.308H8.07841ZM15.6038 16V8.728H15.3878L14.2598 11.392H12.6518L14.3678 7.6H17.1398V16H15.6038Z",
    fill: "#FF865D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional1ActivityCoral);
export default __webpack_public_path__ + "static/media/additional-1-activity-coral.77849a10c31d0900335fd7b96c6d1fbe.svg";
export { ForwardRef as ReactComponent };